export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";
export const PORTAL_LOGIN = "PORTAL_LOGIN";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const LOGOUT = "LOGOUT";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const REGISTER_DISTRIBUTOR_DETAILS = "REGISTER_DISTRIBUTOR_DETAILS";
export const UPLOAD_DRUG_LICENCE = "UPLOAD_DRUG_LICENCE";
export const UPLOAD_GST_CERTIFICATE = "UPLOAD_GST_CERTIFICATE";
export const DISTRIBUTOR_CONTACT_DETAILS = "DISTRIBUTOR_CONTACT_DETAILS";
export const CREATE_NEW_PASSWORD = "CREATE_NEW_PASSWORD";

export const PROFILE_INFO = "PROFILE_INFO";
export const CURRENT_ORDER_LIST = "CURRENT_ORDER_LIST";
export const ORDER_HISTORY_LIST = "ORDER_HISTORY_LIST";
export const ORDER_DETAIL = "ORDER_DETAIL";
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
export const UPLOAD_INVOICE = "UPLOAD_INVOICE";
export const UPDATE_INVOICE = "UPLDATE_INVOICE";
export const COMPANY_LIST = "COMPANY_LIST";
export const STOCK_RECONCILIATION_EXPORT = "STOCK_RECONCILIATION_EXPORT";
export const CFA_ORDER_LIST = "CFA_ORDER_LIST";
export const SUPPLY_ORDER_CFA = "SUPPLY_ORDER_CFA";
export const SUPPLY_ORDER_DETAIL = "SUPPLY_ORDER_DETAIL";
export const CFA_UPDATE_INVOICE = "CFA_UPDATE_INVOICE";
export const ORDER_REMARKS_REASON_LIST = "ORDER_REMARKS_REASON_LIST";

export const CITY_LIST = "CITY_LIST";
export const DISTRICT_LIST = "DISTRICT_LIST";
export const PINCODE_AUTO_LIST = "PINCODE_AUTO_LIST";

export const STATE_LIST = "STATE_LIST";
export const FAQ_LIST = " FAQ_LIST";
export const SUPPORT_CREATE = "SUPPORT_CREATE";
export const DISTRIBUTER_PROFILE = "DISTRIBUTER_PROFILE";
export const DISTRIBUTER_EDIT = "DISTRIBUTER_EDIT";
export const DISTRIBUTOR_IMG_LOGO = "DISTRIBUTOR_IMG_LOGO";

export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
